module.exports = __webpack_public_path__ + "img/01.16cbbe96.jpg";